import { MetaReducer } from '@ngrx/store';
import { MapSurveyMiddleware } from './middlewares/map-survey.middleware';

export const metaReducers: MetaReducer<any>[] = [MapSurveyMiddleware];

export const effectMiddleware: Array<any> = [];
